angular.module('impactx.basket').controller('BasketRequestedDatesDialogCtrl', BasketRequestedDatesDialogCtrl);

BasketRequestedDatesDialogCtrl.$inject = ['$mdDialog', 'dataGen'];

function BasketRequestedDatesDialogCtrl($mdDialog, dataGen)
{
    var ctrl = this;

    ctrl.requestedDeliveryDateRange = angular.copy(ctrl.dateHolder.requestedDeliveryDateRange);
    ctrl.requestedDeliveryDates = angular.copy(ctrl.dateHolder.requestedDeliveryDates);

    ctrl.minDate = new Date();
    ctrl.clearDates = function () {
        ctrl.requestedDeliveryDates.forEach(function (dateObj) {
            dateObj.dateValue = null;
            dateObj.startHour = null;
            dateObj.endHour = null;
        });
    }

    ctrl.abort = function () {
        $mdDialog.cancel();
    };

    ctrl.apply = function () {
        ctrl.dateHolder.requestedDeliveryDateRange = ctrl.requestedDeliveryDateRange;
        ctrl.dateHolder.requestedDeliveryDates = ctrl.requestedDeliveryDates;
        $mdDialog.hide();
    }

    ctrl.updateTimes = function () {
        var dateHolder = {
            requestedDeliveryDateRange: ctrl.requestedDeliveryDateRange,
            requestedDeliveryDates: ctrl.requestedDeliveryDates
        }
        dataGen.postAsForm({}, {bksId: ctrl.bksId, dateHolder: dateHolder},
            "/basket/updatetimes", null, true).then(function (data) {
            ctrl.requestedDeliveryDateRange = angular.copy(data.data.requestedDeliveryDateRange);
            ctrl.requestedDeliveryDates = angular.copy(data.data.requestedDeliveryDates);
        });
    }

    ctrl.changeTimeframe = function(rdd, selected) {
        rdd.start.dateValue = selected.start.dateValue;
        rdd.end.dateValue = selected.end.dateValue;
    }
}